/**
 * Common focus styles utility for consistent focus behavior across components
 */

export const focusStyles = {
  ring: "focus:outline-none focus:ring-2 focus:ring-brand-secondary focus:ring-offset-2 focus:ring-offset-surface-default",
  ringSubtle: "focus:outline-none focus:ring-1 focus:ring-brand-secondary focus:ring-offset-1 focus:ring-offset-surface-default",
  ringStrong: "focus:outline-none focus:ring-3 focus:ring-brand-secondary focus:ring-offset-2 focus:ring-offset-surface-default",
} as const;

export const hoverStyles = {
  scale: "transition-all duration-300 transform hover:scale-105",
  scaleSubtle: "transition-all duration-200 transform hover:scale-102",
  scaleStrong: "transition-all duration-300 transform hover:scale-110",
} as const;

export const disabledStyles = {
  default: "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100",
  subtle: "disabled:opacity-40 disabled:cursor-not-allowed",
} as const;

// Common button style combinations for DRY principle
export const buttonStyles = {
  primary: "bg-brand-primary text-text-primary border-2 border-brand-primary hover:border-brand-secondary hover:bg-brand-primary/80",
  secondary: "border-2 border-border-default bg-surface-alt text-text-primary hover:border-brand-secondary",
  age: "border-2 border-border-default bg-surface-alt text-text-primary hover:border-brand-secondary",
  ageSelected: "border-brand-secondary bg-brand-secondary text-text-inverse",
} as const;

// Common layout utilities
export const layoutStyles = {
  centerContent: "flex items-center justify-center",
  centerContentCol: "flex flex-col items-center justify-center",
  fullscreenCenter: "min-h-screen flex items-center justify-center",
  fullscreenCenterCol: "min-h-screen flex flex-col items-center justify-center",
} as const;
